import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { employeesAPI, departmentsAPI } from '../../lib/api';

const Employees = () => {
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [employeesRes, departmentsRes] = await Promise.all([
        employeesAPI.getAll(),
        departmentsAPI.getAll()
      ]);
      setEmployees(employeesRes.data);
      setDepartments(departmentsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getDepartmentName = (deptId) => {
    const dept = departments.find(d => d.id === deptId);
    return dept?.name || '-';
  };

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'position', label: 'Position' },
    { key: 'department_id', label: 'Department', render: (val) => getDepartmentName(val) },
    { key: 'salary', label: 'Salary', type: 'currency' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Full Name', required: true, placeholder: 'Employee name' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'employee@company.com' },
    { name: 'phone', label: 'Phone', placeholder: '+1-555-0000' },
    { name: 'position', label: 'Position', placeholder: 'Job title' },
    {
      name: 'department_id',
      label: 'Department',
      type: 'select',
      options: departments.map(d => ({ value: d.id, label: d.name })),
    },
    { name: 'hire_date', label: 'Hire Date', type: 'date' },
    { name: 'salary', label: 'Monthly Salary', type: 'number', defaultValue: 0 },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'active',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'on_leave', label: 'On Leave' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await employeesAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await employeesAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await employeesAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Employees"
      description="Manage employee information"
      data={employees}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Employees;
